/**
 * Platform Billing — AI Usage Cost Ledger DTOs & Top-up Config
 * ============================================================
 * The entire AI domain is USD: the cost ledger is USD-canonical (provider cost
 * is intrinsically USD), and the AI budget + top-up credits are USD for every
 * org. There is no FX on the AI path. (Subscriptions remain dual-currency; that
 * lives in `Pricing.ts`, not here.)
 *
 * Naming follows N1: `PlatformBilling*DTO`.
 */
import { PlatformFeatureCode } from "./PlatformPlan.js";
export const PLATFORM_BILLING_TOPUP_CONFIG = {
    minCents: 500, // $5
    maxCents: 50000, // $500
    currency: "USD",
};
/** Stripe Checkout `metadata.kind` marking a session as a custom AI credit top-up. */
export const AI_CREDIT_TOPUP_KIND = "ai_credit_topup";
export const PLATFORM_ADDON_PRODUCTS = [
    {
        type: "animals",
        featureCode: PlatformFeatureCode.MAX_ANIMALS,
        unitStep: 250,
        priceCents: { USD: 1000, BRL: 5000 }, // $10 / R$50 per +250 animals/mo
    },
    {
        type: "farms",
        featureCode: PlatformFeatureCode.MAX_ESTABLISHMENTS,
        unitStep: 1,
        priceCents: { USD: 1000, BRL: 5000 }, // $10 / R$50 per +1 farm/mo
    },
];
/** Look up an add-on product by type. */
export function getPlatformAddonProduct(type) {
    return PLATFORM_ADDON_PRODUCTS.find((a) => a.type === type);
}
/**
 * Stable price-book slot for an add-on line: `addon_<type>_<currency>` lowercased,
 * e.g. `addon_animals_usd`. Must match the catalog `slot` in
 * `ruralops_stripe_catalog.hcl`. Addons are recurring-monthly, so the cycle is
 * implicit (no cycle segment). This is the sole link between an add-on here and
 * its Stripe price ID in STRIPE_PRICE_BOOK — the backend resolves it at runtime
 * (`resolveAddonPriceIdFromBook`) and asserts coverage at boot.
 */
export function addonPriceSlot(type, currency) {
    return `addon_${type}_${currency.toLowerCase()}`;
}
/** Look up the add-on product governing a feature code (if any). */
export function getPlatformAddonByFeatureCode(featureCode) {
    return PLATFORM_ADDON_PRODUCTS.find((a) => a.featureCode === featureCode);
}
//# sourceMappingURL=PlatformBilling.js.map